import { render, staticRenderFns } from "./GameView.vue?vue&type=template&id=5283aedc&"
import script from "./GameView.vue?vue&type=script&lang=js&"
export * from "./GameView.vue?vue&type=script&lang=js&"
import style0 from "./GameView.vue?vue&type=style&index=0&id=5283aedc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports